import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CustomerProposalWrapperToken } from '../modules/ComponentsLibrary/ServiceCall/components/CustomerProposalWrapper';

export const Route = createFileRoute('/customer-proposal/$token')({
  component: RouteComponent,
  params: z.object({
    token: z.string().min(1),
  }),
  head: () => ({
    meta: [
      {
        title: 'Customer Proposal Review',
      },
    ],
  }),
});

function RouteComponent() {
  const { token } = Route.useParams();

  return (
    <CustomerProposalWrapperToken
      token={token}
      reload={() => {
        window.location.reload();
      }}
    />
  );
}
